// @flow

export const SAVE_ANSWERS: 'SAVE_ANSWERS' = 'SAVE_ANSWERS';



// WEBPACK FOOTER //
// ./app/CaptureFeedback/Form/actionTypes.js